import { Button, Modal } from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { updateShowTrimExitWarning } from 'actions/trimming';
import { TRIM_CANCELLED } from 'constants/events';
import { leaveTrimModeCreator } from 'creators/trimming';
import { selectShowExitWarning, selectTrimRanges } from 'selectors/trimming';
import { selectVideoId } from 'selectors/video';
import * as analytics from 'utilities/analytics';
import { useClipsState } from 'components/share-video/edit-tools/clips/state';

const TrimExitWarningModal = (): JSX.Element => {
  const dispatch = useDispatch();
  const showExitWarning = useSelector(selectShowExitWarning);
  const trimRanges = useSelector(selectTrimRanges);
  const videoId = useSelector(selectVideoId);
  const closeModal = () => dispatch(updateShowTrimExitWarning(false));

  const { resetState } = useClipsState(state => ({
    resetState: state.resetState,
  }));

  const goBackToVideo = () => {
    resetState();
    dispatch(leaveTrimModeCreator());

    analytics.track(TRIM_CANCELLED, {
      id: videoId,
      // @ts-expect-error ignoring in bulk: https://github.com/loomhq/loom/pull/10341
      has_been_trimmed: trimRanges.length > 0,
      event_type: 'click',
    });
  };

  return (
    <Modal
      title="There are unsaved changes to your video."
      isOpen={Boolean(showExitWarning)}
      onCloseClick={closeModal}
      onBackgroundClick={closeModal}
      mainButton={
        <Button variant="danger" onClick={goBackToVideo}>
          Discard changes
        </Button>
      }
      secondaryButton={<Button onClick={closeModal}>Continue editing</Button>}
    >
      Are you sure you want to discard them?
    </Modal>
  );
};

export default TrimExitWarningModal;
